import { render, staticRenderFns } from "./liveEventsDetail.vue?vue&type=template&id=1cc361b1&scoped=true&"
import script from "./liveEventsDetail.vue?vue&type=script&lang=js&"
export * from "./liveEventsDetail.vue?vue&type=script&lang=js&"
import style0 from "./liveEventsDetail.vue?vue&type=style&index=0&id=1cc361b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc361b1",
  null
  
)

export default component.exports